<script setup lang="ts">
const route = useRoute();
const { data } = await useKirbyData(route.path, {
  transform: (page: Record<string, any>) => slimPagePayload(page),
});

// Set the current page data for the global page context
setPage(data.value);
usePageJsonLd(computed(() => data.value), () => route.path);

useHead({
  bodyAttrs: {
    class: `news-page`,
  },
});
definePageMeta({
  layout: "default",
});
</script>

<template>
  <div>
    <AppHeading1 />
    <AppHeroImage />
    <div class="content-wrapper">
      <div class="container">
        <div class="intro-text">
          <div v-html="data?.newsIntro" />
        </div>
        <LazyAppArticlesList />
      </div>
    </div>
  </div>
</template>
